<template>
  <div ref="container" class="device-monitor-report">
    <!-- <div class="toggle-collapse">
      <span>{{ '状态报告' | translateTo(i18nPath) }}</span>
      <div class="toggle-icon" @click="changeCollapse">
        <em :class="reportCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></em>
      </div>
    </div> -->
    <div class="content" ref="content">
      <div class="classification">
        <el-radio-group v-model="stateModel" size="mini">
          <el-radio-button v-for="(v, i) in stateReportModels" :label="v.label" :key="i">
            {{ $t(v.text) }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <DeviceReport :reportArray="reportData" />
    </div>
  </div>
</template>

<script>
import DeviceReport from '@/components/device-report';
import { mapState, mapGetters } from 'vuex';
import { stateReportModels } from '@/utils/dict';
import anime from 'animejs';

export default {
  components: { DeviceReport },
  data() {
    return {
      i18nPath: 'monitor.report',
      stateModel: 'all',
      reportCollapse: true,
      stateReportModels
    };
  },
  computed: {
    ...mapState('socket', ['devicesReport']),
    ...mapGetters('socket', ['devicesReportWarn', 'devicesReportDanger']),
    reportData() {
      if (this.stateModel === 'all') {
        return this.devicesReport;
      } else if (this.stateModel === 'warn') {
        return this.devicesReportWarn;
      } else if (this.stateModel === 'danger') {
        return this.devicesReportDanger;
      }
      return this.devicesReport;
    }
  },
  methods: {
    changeCollapse() {
      this.reportCollapse = !this.reportCollapse;
      this.toggleContent(this.reportCollapse);
    },
    toggleContent(flag) {
      const content = this.$refs.content;
      const container = this.$refs.container;
      const tl = anime.timeline({
        easing: 'easeOutExpo'
      });
      if (flag) {
        tl.add({
          targets: content,
          translateX: '100%',
          duration: 500
        });
        tl.finished.then(() => {
          anime.set(container, { width: '160px' });
        });
      } else {
        anime.set(container, {
          width: 'calc(40% - 30px)'
        });
        tl.add({
          targets: content,
          translateX: 0,
          duration: 500
        });
      }
    }
  },
  mounted() {
    this.changeCollapse();
  }
};
</script>

<style lang="scss">
.device-monitor-report {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 9;

  box-sizing: border-box;

  width: calc(40% - 30px);
  height: 300px;
  overflow: hidden;

  pointer-events: none;

  .toggle-collapse {
    display: flex;
    justify-content: right;
    align-items: center;
    user-select: none;

    font-size: 22px;

    .toggle-icon {
      color: #f1ff52;
      font-size: 26px;

      pointer-events: auto;
      cursor: pointer;
    }
  }

  .content {
    position: absolute;
    left: 0%;
    width: 100%;
    // height: calc(260px - 30px);
    height: 100%;
    user-select: none;

    .el-radio-button {
      pointer-events: auto;
    }

    .device-report {
      margin-top: 0;
      pointer-events: auto;
    }
    .classification {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
